import * as React from 'react'

import type { IconProps } from './types'

const NextJs = React.forwardRef<SVGSVGElement, Omit<IconProps, 'color'>>((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        fill="#000"
        d="M7.058.76c-.029.003-.12.012-.204.018-1.915.173-3.71 1.207-4.846 2.795A6.7 6.7 0 0 0 .818 6.52c-.054.37-.06.48-.06.982 0 .503.006.612.06.982a6.77 6.77 0 0 0 4.612 5.449c.438.14.9.237 1.424.295.204.022 1.088.022 1.292 0a6.8 6.8 0 0 0 2.43-.71c.115-.06.138-.076.122-.089-.01-.008-.505-.67-1.098-1.472l-1.078-1.457-1.351-2a192 192 0 0 0-1.36-1.998c-.006-.001-.011.887-.014 1.972-.004 1.9-.005 1.976-.03 2.02a.24.24 0 0 1-.115.12c-.042.022-.08.026-.278.026h-.228l-.06-.038a.25.25 0 0 1-.09-.097l-.027-.059.003-2.643.004-2.644.04-.052a.4.4 0 0 1 .098-.08c.054-.027.075-.03.303-.03.27 0 .314.011.384.088.02.02.751 1.123 1.627 2.45.875 1.328 2.072 3.14 2.66 4.03l1.068 1.618.054-.036a7 7 0 0 0 1.385-1.215 6.7 6.7 0 0 0 1.587-3.448c.054-.37.06-.48.06-.982s-.006-.611-.06-.982A6.77 6.77 0 0 0 9.57 1.071 7 7 0 0 0 8.166.777 17 17 0 0 0 7.058.76m2.76 4.079a.27.27 0 0 1 .134.155c.01.034.013.767.01 2.42l-.003 2.37-.418-.641-.42-.641V6.779c0-1.114.006-1.74.014-1.77a.27.27 0 0 1 .13-.166c.054-.028.074-.03.281-.03.195 0 .23.002.273.026"
      />
      <path
        fill="#000"
        d="M11.09 13.21c-.046.03-.06.05-.02.027.029-.017.076-.053.069-.054a.3.3 0 0 0-.05.027m-.091.06q-.037.027.005.005c.016-.008.029-.017.029-.02 0-.01-.007-.008-.034.015m-.066.04q-.037.027.005.005c.016-.008.03-.018.03-.02 0-.01-.008-.008-.035.014m-.066.039q-.037.027.005.005c.016-.008.03-.017.03-.02 0-.01-.007-.008-.035.015m-.1.053c-.05.026-.048.037.002.012a.1.1 0 0 0 .04-.027c0-.009-.001-.008-.042.015"
      />
    </svg>
  )
})
NextJs.displayName = 'NextJs'
export default NextJs
